import { ReschedulerProps } from './types';
import { ReschedulerProvider } from '@contexts/rescheduler';
import { RelatedSchedulesDialog } from '@components/schedules/dialogs/related';
import { PhoneRelatedSchedules } from '@components/schedules/dialogs/related/mobile';
import { useIsPhone } from '@hooks/useIsPhone';
import { ScheduleDialog } from './dialog';
import { ScheduleConfirmationDialog } from '@components/schedules/dialogs/internal/confirmation';

export const Rescheduler = (props: ReschedulerProps) => {
  const isPhone = useIsPhone();

  return (
    <ReschedulerProvider>
      <ScheduleDialog {...props} />
      {props.phoneLayout && isPhone ? <PhoneRelatedSchedules /> : <RelatedSchedulesDialog />}
      <ScheduleConfirmationDialog />
    </ReschedulerProvider>
  );
};
